export function getAssetImageUrl(url) {
  return new URL(`../assets/image/${url}`, import.meta.url).href;
}
